import { render, staticRenderFns } from "./LogoFinder.vue?vue&type=template&id=1dd174e6&"
import script from "./LogoFinder.vue?vue&type=script&lang=js&"
export * from "./LogoFinder.vue?vue&type=script&lang=js&"
import style0 from "./LogoFinder.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QInput,QIcon});qInstall(component, 'directives', {ClosePopup});
